import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { UniqueIDService } from 'src/app/services/unique-id/unique-id.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { LogoutService } from 'src/app/services/logout/logout.service';

@Component({
  selector: 'app-reset-password-2-fa',
  templateUrl: './reset-password-2-fa.component.html',
  styleUrls: ['./reset-password-2-fa.component.scss'],
})
export class ResetPassword2FAComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;

  @Input() tokenURL: any;
  user2FAMethod;
  isSMS: boolean;
  isAuthApp: boolean;
  titlelbl;


  error = null;
  tokenExpired = false;
  verifiedCode: boolean;
  showMessageSMSSent: boolean;
  // customer: CustomerModel;
  channels: string[];
  phoneNumber;
  currentDisplayChannel: string;
  bypassPinSuccessUI = false; // it is by design in some case
  loginUrl;
  finalTokenURL;
  customerId;
  token: string = null;
  mfaMethod;
  tokenResponseCompleted: Promise<boolean>;
  email: any;
  public showData = false;

  constructor(
    private uniqueIDService: UniqueIDService,
    private authenticationService: AuthenticationService,
    private logoutService: LogoutService,
    private navigator: Navigator,
    private utils: UtilsService
  ) {

  }

  ngOnInit() {
    let holdURL = this.tokenURL;
    console.log(holdURL)
    let getQueryString = holdURL?.split("?")[1]
    let token = getQueryString?.split('=')[1];
    this.finalTokenURL = token?.split('#')[0];
    console.log(this.finalTokenURL)
    this.getToken(this.finalTokenURL);
    this.uniqueIDService.removeMFADeviceId();
  }

  getToken(data) {
    if (data) {
      this.utils.removeUrlParams();
      this.onValidateToken(data);
    } else {
      console.log('token not received');
      this.showData = true;
    }
  }

  onValidateToken(token) {

    this.authenticationService.callValidateToken(token).subscribe({
      next: (response: any) => {
        if (response && !!response.result) {
          this.error = null;

          this.content?.scrollToTop();
          this.customerId = response.payload.customer_id;
          this.phoneNumber = response.payload.phone_number;
          this.email = response.payload.email;
          this.mfaMethod = response.payload.mfa_method;
          this.token = token;
          this.tokenExpired = false;
          this.tokenResponseCompleted = Promise.resolve(true);
          if (!!this.mfaMethod) {
            if (this.mfaMethod.toLowerCase() === 'sms') {
              this.navigator.navigateTo("ResetPasswordMFAComponent", {}, { "token": this.token, "phoneNumber": this.phoneNumber, "customerId": this.customerId });
            } else {
              this.navigator.navigateTo("ResetPasswordMfaAuthAppComponent", {}, { "token": this.token, "customerId": this.customerId });
            }
          } else {
            this.navigator.navigateTo("ResetPasswordMFAComponent", {}, { "token": this.token, "email": this.email, "customerId": this.customerId });
          }
        } else {
          this.showData = true;
        }
      },
      error: (error) => {
        switch (error.getErrorCode().toUpperCase()) {
          case 'INVALID_TOKEN':
            error.setErrorMessage('The token provided is invalid');
            break;
          case "TOKEN_EXPIRED":
            error.setErrorMessage('The token provided is expired');
            break;
        }
        this.error = error;
        this.tokenExpired = true;
        this.tokenResponseCompleted = Promise.resolve(true);
        this.content?.scrollToTop(10);
        this.showData = true;
      }
    });
  }

  closeModal = () => {
    this.navigator.dismiss();
    return this.logoutService.onLogout();
  };

}
